/** ラクエンロゴ。共通画面と世界毎の画面で使い回す */
export default function Logo() {
  return (
    <div className="logo">
      <img className="logo-img" src="/ui/logo-rakuen.webp" alt="RAKUEN" width={720} height={339} />
      <p className="logo-sub">ラクエン</p>
    </div>
  );
}
